import { render, staticRenderFns } from "./SectionActivityTypeList.vue?vue&type=template&id=dd32892a"
import script from "./SectionActivityTypeList.vue?vue&type=script&lang=js"
export * from "./SectionActivityTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports